import { render, staticRenderFns } from "./pickmain.vue?vue&type=template&id=21eeb68b&scoped=true"
import script from "./pickmain.vue?vue&type=script&lang=js"
export * from "./pickmain.vue?vue&type=script&lang=js"
import style0 from "./pickmain.vue?vue&type=style&index=0&id=21eeb68b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eeb68b",
  null
  
)

export default component.exports